import { ComponentsProps } from '@material-ui/core/styles/props';

export const muiDialogProps = (): ComponentsProps => ({
  MuiDialog: {
    PaperProps: {
      square: true,
    },
  },
  MuiDialogTitle: {
    disableTypography: true,
  },
});
